// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".associated_customer_line[data-v-1fcc371f] {\n  height: 2px;\n  width: 100%;\n  background-color: #aaa;\n  margin: 30px 0;\n}\n[data-v-1fcc371f] .is-top {\n  font-size: 13px;\n}\n.footer-btn[data-v-1fcc371f] {\n  position: absolute;\n  bottom: 0;\n  right: 10px;\n}\n.footer-btn button[data-v-1fcc371f] {\n  width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
